import Router from "next/router";

export const navToPath = (path, as, action = "push") => Router[action](path, as);

export const gotoPath = (path, as, action) => () => navToPath(path, as, action);
export const reload = () => Router.replace(window.location.href);
